<div class="m-3">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-header-left" style="font-size: 30px; font-weight: bold">
        Bulk Update
      </div>
      <div class="modal-header-right">
        <button type="button" class="close" (click)="close()">
          <i class="icon-close"></i>
        </button>
      </div>

    </div>
  </div>
  <div class="ml-3 pl-1">
    <strong>
      Changes will reflect in the selected records. Any field not edited below will remain unchanged.
    </strong>
  </div>
  <section class="records-main-section new-records-main-section">
    <form *ngIf="form" [formGroup]="form">
      <div class="tabs-conatent-main edit-form">
        <div class="tab-inner-main-root-bx">
          <div class="row">
            <div class="col-md-4">
              <h3 class="text-right">Field Name</h3>
            </div>
            <div class="col-md-2">
              <h3 >Update Field</h3>
            </div>
            <div class="col-md-6">
              <h3>Field Value</h3>
            </div>
          </div>
          <ng-container *ngFor="let col of fields">
            <ng-container *ngIf="fieldIdToControl(col.FieldName) as control">
              <div class="row" style="align-items: center; height: min-content;">
                <div class="col-md-4 text-right" style="margin-top: -15px;">
                  {{ col.Name }}
                </div>
                <div class="col-md-2 text-right">
                  <app-checkbox
                    [form]="control"
                    controlName="IsDisabled"
                    type="toggle"
                  ></app-checkbox>
                </div>
                <div class="col-md-6">
                  <ng-container
                    *ngTemplateOutlet="
                      inputTypeSelector(col);
                      context: { col: col, control: control }
                    "
                  ></ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary float-right btn-lg update-btn"
          [disabled]="isFormValid()"
          (click)="update()"
        >
          Update
        </button>
      </div>
    </form>
  </section>

  <ng-template let-col="col" let-control="control" #input>
    <app-input
      class="form-group"
      [infoText]="col.Info"
      [form]="control"
      controlName="Value"
      [type]="inputFieldType(col)"
      [isRequired]="col.FieldType === 'PII2' && !col.IsNullable"
      [placeholder]="inputFieldPlaceholder(col)"
      [mask]="inputFieldMask(col)"
      [disabled]="!columnFilter(col) || !(control?.value?.IsDisabled ?? false)"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
    ></app-input>
  </ng-template>
  <ng-template let-col="col" let-control="control" #checkbox>
    <div class="form-custom-div">
      <div class="form-group radio-form-group">
        <div class="custom-radio-root" style="margin-top: 10px; padding-top: 10px;">
          <app-radio [form]="control" controlName="Value"
            [disabled]="!(control?.value?.IsDisabled ?? false)" value="true" label="True"></app-radio>
          <app-radio [form]="control" controlName="Value"
            [disabled]="!(control?.value?.IsDisabled ?? false)" value="false" label="False"></app-radio>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template let-col="col" let-control="control" #select>
    <app-select
      class="form-group"
      [options]="getDropdownValues(col)"
      [id]="col.Key"
      [infoText]="col.Info"
      [fieldName]="col.FieldName"
      [customPlaceholder]="
        control?.value?.Value === multiple_values ? multiple_values : ''
      "
      [form]="control"
      controlName="Value"
      [disabled]="!(control?.value?.IsDisabled ?? false)"
      [isFormAction]="isFormActionAllowed(col)"
      [defaultSelectionLabel]="col.Name.replace('Related ', '')"
      [relatedTableId]="col.RelatedTableKey"
      [relatedFormId]="col.RelatedFormKey"
      [modalLayer]="modalLayer"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
    >
    </app-select>
  </ng-template>

  <ng-template let-col="col" let-control="control" #select2>
    <div>
      <app-select
        class="form-group"
        [options]="getDropdownValues(col)"
        [id]="col.FieldName"
        [infoText]="col.Info"
        [multiple]="true"
        [fieldName]="col.FieldName"
        [customPlaceholder]="
        control?.value?.Value === multiple_values ? multiple_values : ''
      "
        [form]="control"
        [value]="control?.value?.Value"
        controlName="Value"
        [disabled]="!(control?.value?.IsDisabled ?? false)"
        [isFormAction]="isFormActionAllowed(col)"
        [defaultSelectionLabel]="col.Name.replace('Related ', '')"
        [relatedTableId]="col.RelatedTableKey"
        [relatedFormId]="col.RelatedFormKey"
        [modalLayer]="modalLayer"
        (selected)="setMultiSelectedValue($event, form)"
        [IsFromForm]="true"
        [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
        [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
        [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
        >
      </app-select>
    </div>
  </ng-template>

  <ng-template let-col="col" let-control="control" #selectSearchScroll>
    <app-select-search-scroll
      [form]="control"
      controlName="Value"
      [disabled]="!(control?.value?.IsDisabled ?? false)"
      [isSubscriptionComponent]="col.IsRelation ? false : true"
      [options]="col.IsRelation ? (relatedOptions?.[col.Key] || [{ value: '', label: DROPDOWN_VALUE_PLACEHOLDER}]) : userOptions"
      [infoText]="form.value?.Info"
      [minSearchLength]="3"
      [searchable]="isUserField(col)"
      [scrollable]="isUserField(col)"
      (selected)="setSelectedValue($event, control)"
      [IsFromForm]="true"
      [virtualScroll]="col.IsRelation ? true : false"
      [isRelatedDataComponent]="col.IsRelation"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
      [relatedFieldKey]="col.Key"
      [relatedTableId]="col.RelatedTableKey"
      [relatedFormId]="col.RelatedFormKey"
      [passedTableKey]="relatedTableId"
      [isFormAction]="col.IsFlyAdditionAllowed"
      [dropdownFieldKey]="col.IsRelation ? col.ProxyFieldKey : ''"
      [dropdownType]="col.IsRelation ? col.ProxyFieldType : ''"
      [defaultSelectionLabel]="relatedSingularNames[col.Key] || col.Name.replace('Related ', '')"
      [modalLayer]="modalLayer"
    ></app-select-search-scroll>
  </ng-template>

  <ng-template let-col="col" let-control="control" #textarea>
    <app-textarea
      class="form-group"
      [infoText]="col.Info"
      [form]="control"
      controlName="Value"
      [disabled]="!(control?.value?.IsDisabled ?? false)"
      [IsFromForm]="true"
      [IsInfoVisible]="col?.FormFieldSetting?.IncludeInfoText"
      [DisplayOnScreen]="col?.FormFieldSetting?.DisplayType == 1"
      [AllowMinimize]="col?.FormFieldSetting?.AllowMinimize"
    ></app-textarea>
  </ng-template>
</div>